import React from "react";
import { Button, Form, Radio } from "antd";
import FormToggleButton from "./inputWidgets/ButtonSwitch";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CommonButton = ({ buttonsData }) => {
  return (
    <div className="flex items-center mt-2">
      {buttonsData.map((button, index) => {
        if (button.renderLabel) {
          return (
            <div className="mr-2 border-[1px] border-customColor bg-customColor_10 rounded-md px-[10px] h-[30px] inline-flex items-center">
              <span className="text-sm font-medium text-gray-700 mr-2">
                {button?.label}
              </span>
              <span className="text-sm font-bold text-customColor">
                {button?.value}
              </span>
            </div>
          );
        }
        if (button.radioOptions) {
          return (
            <>
              <Form.Item name={button?.name}>
                <Radio.Group
                  options={button?.radioOptions}
                  onChange={(e) => button?.onChange(e.target.value)}
                  buttonStyle="solid"
                  size="small"
                  disabled={button?.disabled}
                  className="mr-2 min-w-[104px] h-[30px] py-1 px-[10px] font-medium inline-flex items-center bg-[#E9E9E9] border border-[#d9d9d9] text-customColor rounded rounded-md"
                />
              </Form.Item>
            </>
          );
        }
        if (button.toggle) {
          return (
            <FormToggleButton
              name={button?.name}
              buttonLabel={button?.label}
              initialValue={false}
              onChange={button?.onChange}
              disabled={button?.disabled}
            />
          );
        }
        return (
          <Button
            key={index}
            type={button?.label === "Cancel" ? "" : "primary"}
            //   icon={<FontAwesomeIcon icon={button.icon} />}
            onClick={button?.onClick}
            disabled={button?.disabled}
            loading={button?.loading}
            className={`mr-2 min-w-[104px] h-[30px] py-1 px-[10px] font-medium ${
              button?.label === "Cancel"
                ? "!bg-[#E9E9E9] border  !text-customColor hover:!bg-white hover:!text-customColor"
                : ""
            }`}
          >
            {button?.icon}
            {button?.label}
          </Button>
        );
      })}
    </div>
  );
};

export default CommonButton;
